<template>
  <div>
    <button
      type="button"
      class="btn btn-transparent"
      @click="share"
    >
      <share-icon />
      <span class="small">Share</span>
    </button>
  </div>
</template>

<script>
export default {
  methods: {
    share() {
      alert('COMMING SOON');
    },
  },
};
</script>

<style lang="scss" scoped>
  .small {
    margin-left: 0.25rem;
  }
</style>
